import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
  Box,
} from '@mui/material';

export default function KeyboardShortcutsDialog({ open, onClose }) {
  const rows = [
    { keys: '?', desc: 'Show keyboard shortcuts (when not typing in a field).' },
    { keys: 'Esc', desc: 'Close dialogs (where supported).' },
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6" component="span" fontWeight={700}>
          Keyboard shortcuts
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Press <Box component="kbd" sx={{ px: 0.75, py: 0.25, bgcolor: 'action.hover', borderRadius: 1 }}>?</Box>{' '}
          outside of text fields to open this panel. Navigation uses the sidebar.
        </Typography>
        <List dense>
          {rows.map((r) => (
            <ListItem key={r.keys} sx={{ alignItems: 'flex-start' }}>
              <ListItemText
                primary={
                  <Box component="kbd" sx={{ px: 1, py: 0.5, bgcolor: 'action.hover', borderRadius: 1, fontSize: '0.85rem' }}>
                    {r.keys}
                  </Box>
                }
                secondary={r.desc}
                secondaryTypographyProps={{ component: 'div', variant: 'body2', sx: { mt: 0.5 } }}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
